@let links = urls();

@if (!isIos) {
  <card-wrapper>
    <div class="card">
      <div class="card__header">
        <img
          [src]="baseHref + '/assets/img/logo.svg'"
          alt="FBS trader icon"
          class="card__img"
        />
        <div class="card__header-wrapper">
          <div
            class="card__title"
            translate="mobile-apps-widget.subtitle.personal-area"
          ></div>
          <p
            class="card__description"
            translate="mobile-apps-widget.text.personal-area"
          ></p>
        </div>
      </div>

      <div class="card__links">
        @if (!isIos) {
          <a [href]="links.apk" class="app-link" target="_blank">
            <img
              class="app-link__icon"
              [ngSrc]="baseHref + '/assets/img/mobile-apps-widget/apk.svg'"
              alt="APK version"
              width="110"
              height="44"
            />
          </a>
          @if (isGooglePlayButtonVisible()) {
            <a [href]="links[location()] ?? links.global" class="app-link" target="_blank">
              <img
                class="app-link__icon"
                [ngSrc]="baseHref + '/assets/img/mobile-apps-widget/googleplay.svg'"
                alt="Google Play"
                width="135"
                height="44"
              />
            </a>
          }
        }

  <!--      @if (!isAndroid) {-->
  <!--        <a [href]="urls[location()] ?? urls.global" class="app-link" target="_blank">-->
  <!--          <img-->
  <!--            class="app-link__icon"-->
  <!--            ngSrc="/cabinet/assets/img/mobile-apps-widget/appstore.svg"-->
  <!--            alt="App Store"-->
  <!--            width="142"-->
  <!--            height="44"-->
  <!--          />-->
  <!--        </a>-->
  <!--      }-->

  <!--      <svg-icon-sprite-->
  <!--        [src]="'/cabinet/assets/img/icons/sprite.svg#qr'"-->
  <!--        (click)="showQr()"-->
  <!--        class="app-link app-link__icon app-link__icon&#45;&#45;qr"-->
  <!--      />-->
      </div>
    </div>
  </card-wrapper>
}
